import React from 'react';
import { CountryData, PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { AuthPhoneValue } from 'types/auth';
import { parseAuthPhone } from 'utils/phone';

interface AuthPhoneInputProps {
    value: string;
    defaultCountry: string;
    countries: CountryData[];
    onChange: (phone: string, fields: AuthPhoneValue) => void;
    onBlur?: () => void;
    invalid?: boolean;
    placeholder?: string;
    hideDropdown?: boolean;
    inputId?: string;
}

const AuthPhoneInput: React.FC<AuthPhoneInputProps> = ({
    value,
    defaultCountry,
    countries,
    onChange,
    onBlur,
    invalid,
    placeholder = 'Your Mobile Number',
    hideDropdown = false,
    inputId,
}) => {
    return (
        <div className={`auth-phone-input${invalid ? ' is-invalid' : ''}`}>
            <PhoneInput
                defaultCountry={defaultCountry}
                countries={countries}
                preferredCountries={[defaultCountry]}
                value={value}
                disableDialCodeAndPrefix
                showDisabledDialCodeAndPrefix
                disableCountryGuess
                hideDropdown={hideDropdown}
                placeholder={placeholder}
                onChange={(phone, { country }) => {
                    onChange(phone, parseAuthPhone(phone, country.iso2, country.dialCode));
                }}
                inputProps={{
                    autoComplete: 'off',
                    name: 'mobile',
                    id: inputId,
                    onBlur,
                }}
                countrySelectorStyleProps={{
                    dropdownStyleProps: {
                        style: { zIndex: 20 },
                    },
                }}
            />
        </div>
    );
};

export default AuthPhoneInput;
